import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CTAButton } from './CTAButton';
export function OfferSection() {
  return <SectionWrapper bgColor="forest" className="text-center" id="oferta" data-id="element-90">
      <div className="max-w-2xl mx-auto" data-id="element-91">
        <h2 className="font-serif text-3xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-92">
          Recupera tus noches y tu placer por la comida hoy mismo.
        </h2>

        <p className="text-xl text-brand-cream/90 mb-10" data-id="element-93">
          Por el precio de lo que gastas en una caja de antiácidos al mes,
          puedes tener la solución definitiva de raíz.
        </p>

        <div className="bg-white text-brand-forest p-8 rounded-3xl shadow-2xl mb-10 transform scale-105" data-id="element-94">
          <p className="text-lg font-bold text-gray-500 uppercase tracking-wider mb-2" data-id="element-95">
            Inversión única de
          </p>
          <div className="text-2xl md:text-3xl text-gray-400 line-through mb-2" data-id="element-96">
            $17.00 USD
          </div>
          <div className="text-6xl md:text-7xl font-black text-brand-forest mb-1 tracking-tighter" data-id="element-97">
            $6
            <span className="text-3xl md:text-4xl text-brand-forest font-bold" data-id="element-98">
              ,39
            </span>{' '}
            <span className="text-2xl text-gray-400 font-bold" data-id="element-99">USD</span>
          </div>
          <p className="text-sm font-bold text-brand-amber uppercase tracking-wide mb-4" data-id="element-100">
            ¡Oferta por tiempo limitado!
          </p>

          <div className="mt-8" data-id="element-101">
            <CTAButton className="w-full" data-id="element-102" />
          </div>
        </div>
      </div>
    </SectionWrapper>;
}